import { ICompany } from '@company/types/company';
import { createContext } from 'react';

const CompanyManagementContext = createContext<{
    company?: ICompany;
    permissions?: {
        edit: boolean;
        filter: boolean;
        remove: boolean;
        partnerships: {
            view: boolean;
            manage: boolean;
        };
    };
}>({});

export { CompanyManagementContext };
